<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Cluesters:"
    id="selectCluster"
    placeholder="Selecione o(s) Cluster(s)"
    :multiple="multiple"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>
<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import ClusterRepository from '../../../../shared/http/repositories/configurations/cluster'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectCluster',
  mixins: [useReactiveModelMixin('value')],
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  async created () {
    await this.onLoadPAs()
  },
  methods: {
    async onLoadPAs () {
      try {
        loading.push()

        const { status, data } = await ClusterRepository.GetAll()

        if (data === '') return

        if (status === 200) {
          let result = data.content.map((x) => ({
            value: x.id,
            text: x.descricao
          }))
          this.listOptions = result
        }
      } catch (err) {
        toast.error('Não foi possível carregar a lista de Clusters', 'Erro')
        console.error(err)
      } finally {
        loading.close()
      }
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectCluster.vue